// Validação de CNPJ — suporta o formato numérico antigo e o novo formato
// alfanumérico da Receita (jul/2026): 12 primeiras posições alfanuméricas
// (0-9, A-Z) e 2 últimas numéricas (dígitos verificadores).
//
// O algoritmo de DV (módulo 11) usa o valor ASCII de cada caractere menos 48
// ('0'..'9' => 0..9, 'A'..'Z' => 17..42). CNPJ numérico é caso particular,
// então valores antigos continuam válidos. Mantido alinhado com a validação
// central do backend (Futuro\Common\Rules\CpfCnpjLogic).

// Normaliza: remove máscara/espaços, mantém apenas letras e números, maiúsculas.
const normalize = value => String(value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()

// Calcula um dígito verificador (12 ou 13 posições de base).
const calcDv = base => {
  let soma = 0
  let peso = base.length - 7 // 12 posições => peso inicial 5 ; 13 => 6

  for (let i = 0; i < base.length; i += 1) {
    soma += (base.charCodeAt(i) - 48) * peso
    peso -= 1
    if (peso < 2) peso = 9
  }

  const resto = soma % 11
  return resto < 2 ? '0' : String(11 - resto)
}

function validate(value) {
  if (!value) return false

  const cnpj = normalize(value)

  // 12 posições alfanuméricas (0-9, A-Z) + 2 dígitos verificadores numéricos
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false

  // Rejeita sequência de caracteres todos iguais
  if (new Set(cnpj.split('')).size === 1) return false

  const base = cnpj.slice(0, 12)
  const dv1 = calcDv(base)
  const dv2 = calcDv(base + dv1)

  return cnpj === base + dv1 + dv2
}

export default validate
